/**
 * Ghost Recon — placeholder while the surface is rebuilt on TrendTrack.
 *
 * Replaces GhostReconV2, which drove automated offer discovery: a brief box that
 * fanned out across five research sources and returned generated "opportunities".
 * That flow was retired — offers are sourced from networks directly, and
 * market-wide scanning never produced usable signal.
 *
 * The route and nav entry are kept deliberately. Ghost Recon returns as an
 * on-demand surface backed by TrendTrack: Nick asks, Cipher queries, results
 * come back. Nothing runs in the background.
 *
 * Per-offer analysis still works today and is reachable at /ghost-recon/:offerId.
 */
const GhostReconRebuilding = () => {
  return (
    <div className="max-w-3xl mx-auto py-16 px-6" data-testid="ghost-recon-rebuilding">
      <div className="flex items-center gap-3 mb-6">
        <span className="text-3xl" aria-hidden="true">
          📡
        </span>
        <h1 className="text-2xl font-semibold text-white">Ghost Recon</h1>
        <span className="text-xs uppercase tracking-wider px-2 py-1 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-400">
          Rebuilding
        </span>
      </div>

      <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 space-y-4">
        <p className="text-slate-300 leading-relaxed">
          This surface is being rebuilt on <strong className="text-white">TrendTrack</strong>. It
          will work on demand — you ask, Cipher queries, results come back. No background
          scanning.
        </p>

        <p className="text-slate-400 text-sm leading-relaxed">
          The automated discovery flow that used to live here has been removed. It searched the
          market on its own and produced opportunities nobody asked for, and the signals it
          scored were empty.
        </p>

        <div className="pt-4 border-t border-slate-800">
          <div className="text-xs uppercase tracking-wider text-slate-500 mb-2">
            Still available
          </div>
          <ul className="text-sm text-slate-400 space-y-1 list-disc list-inside">
            <li>Per-offer intelligence briefs, funnels, creatives and comments</li>
            <li>Creative decomposition on a specific ad</li>
            <li>Offer scoring and save-to-pipeline</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default GhostReconRebuilding;
